import { Badge } from '@elkaso-app/web-design';
import {
  facilityStatusLabels,
  getStatusStyle,
  utilizationStatusLabels,
} from 'pages/bnpl/utils/bnpl-statuses';

interface BnplStatusBadgeProps {
  status: string;
  type: 'facility' | 'utilization';
}

const labelMaps: Record<string, Record<string, string>> = {
  facility: facilityStatusLabels,
  utilization: utilizationStatusLabels,
};

export const BnplStatusBadge = ({ status, type }: BnplStatusBadgeProps) => {
  const style = getStatusStyle(status);
  const labels = labelMaps[type] || {};
  const label = labels[status] || status;

  return (
    <Badge
      px='sm'
      py='xs'
      borderRadius='md'
      fontSize='xs'
      fontWeight='semibold'
      color={style.color}
      bg={style.bgColor}>
      {label}
    </Badge>
  );
};
